import * as React from 'react';
import { requestGet, requestPost } from '../../../../modules/request/index';
import { ButtonSpinner, DropdownInput, Input } from '../../../Shared/index';
import GradeOptions from './grade_options';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface CreateAClassFormProps {
  next: Function;
  setClassroom: Function;
  close: (event) => void;
}

interface CreateAClassFormState {
  name: string;
  code: string;
  grade?: { label: string, value: string };
  timesSubmitted: number;
  submitting: boolean;
  errors: { [key:string]: string }
}


export default class CreateAClassForm extends React.Component<CreateAClassFormProps, CreateAClassFormState> {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      code: ' ',
      grade: null,
      timesSubmitted: 0,
      submitting: false,
      errors: {}
    }
  }

  componentDidMount() {
    this.getClassCode()
  }

  getClassCode = () => {
    requestGet('/teachers/classrooms/regenerate_code', (body) => this.setState({ code: body.code }));
  }

  footerButtonClass() {
    const { name, grade, code } = this.state
    let buttonClass = 'quill-button contained medium focus-on-light create-class';
    if (!name.length || !code.length || !grade) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  }

  handleGradeChange = (grade) => {
    this.setState({ grade, });
  }

  handleNameChange = (event) => {
    this.setState({ name: event.target.value })
  }

  handleNameClear = () => {
    this.setState({ name: '' })
  }

  createClass = () => {
    const { name, grade, code, timesSubmitted } = this.state
    const classroom = { name, code, grade: grade.value, }
    this.setState(({ submitting: true }))
    requestPost('/teachers/classrooms', { classroom, }, (body) => {
      if (body && body.errors) {
        this.setState({ errors: body.errors, timesSubmitted: timesSubmitted + 1 });
      } else {
        this.props.setClassroom(body.classroom)
        this.props.next()
      }
      this.setState({ submitting: false });
    })
  }

  renderBody() {
    const { name, grade, code, timesSubmitted, errors } = this.state
    return (
      <div className="create-a-class-modal-body modal-body">
        <h3 className="title">Create a class</h3>
        <form className="create-a-class-form">
          <Input
            characterLimit={50}
            className="large bordered name"
            error={errors.name}
            handleCancel={this.handleNameClear}
            handleChange={this.handleNameChange}
            id="class-name"
            label="Class name"
            placeholder="e.g., Ms. Hall's 6th Period"
            timesSubmitted={timesSubmitted}
            type="text"
            value={name}
          />
          <DropdownInput
            className="bordered large grade focus-on-light"
            error={errors.grade}
            handleChange={this.handleGradeChange}
            helperText="This will not limit the activities you can access."
            label="Grade"
            options={GradeOptions}
            value={grade}
          />

          <div className="class-code-section">
            <Input
              className="code"
              disabled={true}
              helperText="Students use this to join your class."
              id="class-code"
              label="Class code"
              type="text"
              value={code}
            />
            <button aria-label="Reset class code" className="quill-button outlined medium focus-on-light reset" onClick={this.getClassCode} type="button">Reset</button>
          </div>
        </form>
      </div>
    )
  }

  renderFooter() {
    const { close } = this.props
    const { submitting } = this.state
    return (
      <div className="create-a-class-modal-footer">
        <div className="buttons-container">
          <button className="quill-button outlined medium focus-on-light" onClick={close}>Cancel</button>
          {/* DemoGuardedButton needs to be inside of a div because the button shifts when the editing is disabled modal is open */}
          <div>
            <DemoGuardedButton className={this.footerButtonClass()} onClick={this.createClass}>{submitting ? <ButtonSpinner variant="light" /> : 'Create class, next'}</DemoGuardedButton>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="create-a-class-modal-content">
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    )
  }
}
